import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UiButtonComponent } from '@design-system';
import { OrderSide } from '@shared-types';

@Component({
	selector: 'app-buy-sell-button',
	imports: [UiButtonComponent, RouterLink],
	templateUrl: './buy-sell-button.component.html',
	host: {
		class: 'block w-full shrink-0'
	}
})
export class BuySellButtonComponent {
	readonly OrderSide = OrderSide;

	readonly isin = input.required<string>();
	readonly buyDisabled = input(false);
	readonly sellDisabled = input(false);
}
